import { tryGetHostApi } from "../../externalApi/externalApi";
import { tryParseJson } from "../../utils/stringUtilities";
import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
export async function getCommandApi() {
    return (await tryGetHostApi("Commands", 1, 1));
}
export class WidgetCommandApi {
    constructor() {
        this._eventListeners = new Array();
    }
    async initialize() {
        // Attempt to initialize _commandApi
        const commandApi = await getCommandApi();
        // Check if _commandApi is successfully initialized
        if (!commandApi) {
            // Log event if _commandApi is unavailable
            Trace.logEvent(dashboard, "CommandAPIUnavailable", 1 /* information */);
            return;
        }
        // Add an event listener for 'commandsReceived'
        await commandApi.addEventListener("commandsReceived", async (eventData) => {
            // Iterate over all registered event listeners
            for (const listener of this._eventListeners) {
                if (listener) {
                    try {
                        // Try parsing the event data and invoke the listener
                        const commandJSON = tryParseJson(eventData);
                        listener("commandsReceived", commandJSON);
                    }
                    catch (error) {
                        // Log or handle errors from JSON parsing or listener execution
                        Trace.logEvent(dashboard, "Error processing command:" + error, 3 /* error */);
                    }
                }
            }
        });
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        const index = this._eventListeners.indexOf(listener);
        if (index !== -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    async getCommandDetailsAsync() {
        // Ensure _commandApi is initialized
        const commandApi = await getCommandApi();
        // If _commandApi is still not available, log and return null
        if (!commandApi) {
            Trace.logEvent(dashboard, "CommandAPIUnavailable", 1 /* information */);
            return null;
        }
        try {
            // Fetch command details
            const command = await commandApi.getCommandDetails();
            // Parse and return the command details
            const commandJSON = tryParseJson(command);
            return commandJSON || null; // Ensure null is returned if parsing fails
        }
        catch (error) {
            // Handle errors from API call or JSON parsing
            Trace.logEvent(dashboard, "Error fetching or parsing command details:" + error, 3 /* error */);
            return null;
        }
    }
}
